import React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenuIcon from "@mui/icons-material/Menu";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "./images/logo-new.jpg";

const navLinks = [
  { label: "Home", href: "/" },
  { label: "Specials", href: "#specials" },
  { label: "Gallery", href: "/gallery" }, // Change from "#gallery" to "/gallery"
  { label: "About Us", href: "#about" },
];

const NavBar = ({ anchorEl, handleMenuOpen, handleMenuClose }) => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <AppBar
      position="sticky"
      elevation={2}
      sx={{
        background: "linear-gradient(135deg, #0d0d0d 0%, #1a1a1a 100%)",
        color: "#fff",
        borderBottom: "3px solid #FFD700",
        minHeight: { xs: 56, md: 64 },
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ minHeight: { xs: 56, md: 64 } }}>
          {/* Logo and Title */}
          <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
            <img
              src={logo}
              alt="Dizaver Aluminum Logo"
              style={{ height: 48, marginRight: 16 }}
            />
            <Typography
              variant="h4"
              sx={{
                fontFamily: '"Bungee", Arial, sans-serif',
                fontWeight: 700,
                letterSpacing: 2,
                textTransform: "uppercase",
                color: "#fff",
                textShadow: "2px 2px 0 #000, 0 0 2px #fff",
                borderBottom: {
                  xs: "4px solid #fff",
                  md: "4px solid #fff",
                },
                lineHeight: 1.2,
                pb: "2px",
                display: "inline-block",
                fontSize: { xs: "1.1rem", md: "1.7rem" },
                whiteSpace: { xs: "normal", md: "nowrap" },
              }}
            >
              DIZAVER ALUMINUM
            </Typography>
          </Box>
          {/* Desktop Nav Links */}
          <Stack
            direction="row"
            spacing={2}
            sx={{
              alignItems: "center",
              display: { xs: "none", md: "flex" },
              whiteSpace: "nowrap",
            }}
          >
            {navLinks.map((link) =>
              link.label === "Home" ? (
                <Button
                  key={link.label}
                  color="inherit"
                  sx={{
                    fontWeight: 600,
                    fontSize: "1rem",
                    transition: "color 0.2s, background 0.2s, box-shadow 0.2s",
                    borderRadius: 2,
                    px: 2,
                    "&:hover": {
                      color: "#FFD700",
                      background: "transparent",
                      boxShadow: "inset 0 -2px 0 #FFD700",
                    },
                  }}
                  component={Link}
                  to={link.href}
                  onClick={() => {
                    if (location.pathname === "/") {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }
                  }}
                >
                  {link.label}
                </Button>
              ) : link.label === "Specials" ? (
                <Button
                  key={link.label}
                  color="inherit"
                  sx={{
                    fontWeight: 600,
                    fontSize: "1rem",
                    transition: "color 0.2s, background 0.2s, box-shadow 0.2s",
                    borderRadius: 2,
                    px: 2,
                    "&:hover": {
                      color: "#FFD700",
                      background: "transparent",
                      boxShadow: "inset 0 -2px 0 #FFD700",
                    },
                  }}
                  onClick={(e) => {
                    if (location.pathname !== "/") {
                      e.preventDefault();
                      navigate("/", { state: { scrollToSpecials: true } });
                    } else {
                      e.preventDefault();
                      const specialsSection = document.getElementById("specials");
                      if (specialsSection) {
                        specialsSection.scrollIntoView({ behavior: "smooth" });
                      }
                    }
                  }}
                  component={Link}
                  to="/"
                >
                  {link.label}
                </Button>
              ) : link.label === "About Us" ? (
                <Button
                  key={link.label}
                  color="inherit"
                  sx={{
                    fontWeight: 600,
                    fontSize: "1rem",
                    transition: "color 0.2s, background 0.2s, box-shadow 0.2s",
                    borderRadius: 2,
                    px: 2,
                    "&:hover": {
                      color: "#FFD700",
                      background: "transparent",
                      boxShadow: "inset 0 -2px 0 #FFD700",
                    },
                  }}
                  onClick={(e) => {
                    if (location.pathname !== "/") {
                      e.preventDefault();
                      navigate("/", { state: { scrollToAbout: true } });
                    } else {
                      e.preventDefault();
                      const aboutSection = document.getElementById("about");
                      if (aboutSection) {
                        aboutSection.scrollIntoView({ behavior: "smooth" });
                      }
                    }
                  }}
                  component={Link}
                  to="/"
                >
                  {link.label}
                </Button>
              ) : (
                <Button
                  key={link.label}
                  color="inherit"
                  sx={{
                    fontWeight: 600,
                    fontSize: "1rem",
                    transition: "color 0.2s, background 0.2s, box-shadow 0.2s",
                    borderRadius: 2,
                    px: 2,
                    "&:hover": {
                      color: "#FFD700",
                      background: "transparent",
                      boxShadow: "inset 0 -2px 0 #FFD700",
                    },
                  }}
                  component={Link}
                  to={link.href}
                >
                  {link.label}
                </Button>
              )
            )}
            <Button
              color="secondary"
              variant="contained"
              sx={{
                ml: 2,
                fontWeight: 700,
                background: "#FFD700",
                color: "#000",
                fontSize: "1rem",
                px: 3,
                py: 0.8,
                borderRadius: 2,
                transition: "background 0.3s, box-shadow 0.3s, transform 0.2s",
                "&:hover": {
                  background: "#FFC107",
                  boxShadow: "0 6px 20px rgba(218,165,32,0.4)",
                  transform: "translateY(-2px)",
                },
              }}
              href="tel:4378557047"
            >
              (437) 855-7047
            </Button>
            {/* Social Icons */}
            <IconButton
              color="inherit"
              href="https://www.facebook.com/profile.php?id=61577040364013"
              target="_blank"
              rel="noopener"
              sx={{
                ml: 1,
                transition: "background 0.2s, color 0.2s, transform 0.2s",
                "&:hover": {
                  background: "#bdbdbd",
                  color: "#fff",
                  transform: "scale(1.15)",
                },
              }}
              aria-label="Facebook"
            >
              <FacebookIcon />
            </IconButton>
            <IconButton
              color="inherit"
              href="https://www.instagram.com/diza_ver/"
              target="_blank"
              rel="noopener"
              sx={{
                transition: "background 0.2s, color 0.2s, transform 0.2s",
                "&:hover": {
                  background: "#bdbdbd",
                  color: "#fff",
                  transform: "scale(1.15)",
                },
              }}
              aria-label="Instagram"
            >
              <InstagramIcon />
            </IconButton>
            <IconButton
              color="inherit"
              href="https://www.youtube.com/@DizaverAluminum"
              target="_blank"
              rel="noopener"
              sx={{
                transition: "background 0.2s, color 0.2s, transform 0.2s",
                "&:hover": {
                  background: "#bdbdbd",
                  color: "#fff",
                  transform: "scale(1.15)",
                },
              }}
              aria-label="YouTube"
            >
              <YouTubeIcon />
            </IconButton>
          </Stack>
          {/* Mobile Menu Icon */}
          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              edge="end"
              color="inherit"
              aria-label="menu"
              onClick={handleMenuOpen}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              {navLinks.map((link) =>
                link.label === "Specials" ? (
                  <MenuItem
                    key={link.label}
                    onClick={(e) => {
                      handleMenuClose();
                      if (location.pathname !== "/") {
                        navigate("/", { state: { scrollToSpecials: true } });
                      } else {
                        const specialsSection = document.getElementById("specials");
                        if (specialsSection) {
                          specialsSection.scrollIntoView({ behavior: "smooth" });
                        }
                      }
                    }}
                    component={Link}
                    to="/"
                  >
                    {link.label}
                  </MenuItem>
                ) : link.label === "About Us" ? (
                  <MenuItem
                    key={link.label}
                    onClick={(e) => {
                      handleMenuClose();
                      if (location.pathname !== "/") {
                        navigate("/", { state: { scrollToAbout: true } });
                      } else {
                        const aboutSection = document.getElementById("about");
                        if (aboutSection) {
                          aboutSection.scrollIntoView({ behavior: "smooth" });
                        }
                      }
                    }}
                    component={Link}
                    to="/"
                  >
                    {link.label}
                  </MenuItem>
                ) : (
                  <MenuItem
                    key={link.label}
                    onClick={handleMenuClose}
                    component={Link}
                    to={link.href}
                  >
                    {link.label}
                  </MenuItem>
                )
              )}
              <MenuItem
                onClick={handleMenuClose}
                component="a"
                href="tel:4378557047"
                sx={{ fontWeight: 700, color: "#FFD700" }}
              >
                (437) 855-7047
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default NavBar;